// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__2btAm","inputWrap":"styles_inputWrap__11_Tp","input":"styles_input__d_TSK"};